export const disconnectInnerCuttingLineClipPath = (self) => {
  const target_image_inner_wrapper_g_el =
    self._getTargetImageInnerWrapperGElThrowable();
  target_image_inner_wrapper_g_el.removeAttributeNS(null, "clip-path");
};
